var p, E;
function Q() {
  if (E) return p;
  E = 1;
  var L = "Expected a function", j = NaN, _ = "[object Symbol]", C = /^\s+|\s+$/g, M = /^[-+]0x[0-9a-f]+$/i, N = /^0b[01]+$/i, R = /^0o[0-7]+$/i, W = parseInt, $ = typeof globalThis == "object" && globalThis && globalThis.Object === Object && globalThis, q = typeof self == "object" && self && self.Object === Object && self, A = $ || q || Function("return this")(), B = Object.prototype, F = B.toString, P = Math.max, D = Math.min, g = function() {
    return A.Date.now();
  };
  function G(e, t, i) {
    var f, s, d, c, n, a, u = 0, I = !1, l = !1, y = !0;
    if (typeof e != "function")
      throw new TypeError(L);
    t = x(t) || 0, v(i) && (I = !!i.leading, l = "maxWait" in i, d = l ? P(x(i.maxWait) || 0, t) : d, y = "trailing" in i ? !!i.trailing : y);
    function T(r) {
      var o = f, b = s;
      return f = s = void 0, u = r, c = e.apply(b, o), c;
    }
    function X(r) {
      return u = r, n = setTimeout(m, t), I ? T(r) : c;
    }
    function z(r) {
      var o = r - a, b = r - u, k = t - o;
      return l ? D(k, d - b) : k;
    }
    function O(r) {
      var o = r - a, b = r - u;
      return a === void 0 || o >= t || o < 0 || l && b >= d;
    }
    function m() {
      var r = g();
      if (O(r))
        return S(r);
      n = setTimeout(m, z(r));
    }
    function S(r) {
      return n = void 0, y && f ? T(r) : (f = s = void 0, c);
    }
    function J() {
      n !== void 0 && clearTimeout(n), u = 0, f = a = s = n = void 0;
    }
    function K() {
      return n === void 0 ? c : S(g());
    }
    function h() {
      var r = g(), o = O(r);
      if (f = arguments, s = this, a = r, o) {
        if (n === void 0)
          return X(a);
        if (l)
          return n = setTimeout(m, t), T(a);
      }
      return n === void 0 && (n = setTimeout(m, t)), c;
    }
    return h.cancel = J, h.flush = K, h;
  }
  function v(e) {
    var t = typeof e;
    return !!e && (t == "object" || t == "function");
  }
  function H(e) {
    return !!e && typeof e == "object";
  }
  function U(e) {
    return typeof e == "symbol" || H(e) && F.call(e) == _;
  }
  function x(e) {
    if (typeof e == "number")
      return e;
    if (U(e))
      return j;
    if (v(e)) {
      var t = typeof e.valueOf == "function" ? e.valueOf() : e;
      e = v(t) ? t + "" : t;
    }
    if (typeof e != "string")
      return e === 0 ? e : +e;
    e = e.replace(C, "");
    var i = N.test(e);
    return i || R.test(e) ? W(e.slice(2), i ? 2 : 8) : M.test(e) ? j : +e;
  }
  return p = G, p;
}
export {
  Q as __require
};
//# sourceMappingURL=help-center-articles-search20.js.map
